import { render } from "./StudentList.vue?vue&type=template&id=31887a9a&scoped=true&ts=true"
import script from "./StudentList.vue?vue&type=script&lang=ts"
export * from "./StudentList.vue?vue&type=script&lang=ts"

import "./StudentList.vue?vue&type=style&index=0&id=31887a9a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31887a9a"]])

export default __exports__